import React, { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { creditApplicationSelectors } from '../../../services/redux/features/creditApplication.slice';
import { selectDataStorage } from '../../../services/redux/features/dataStorage.redux';
import { quoteSelectors } from '../../../services/redux/features/quote.slice';
import { BusinessCustomerDetailsForms } from './businessCustomerDetailsForms';
import { CoCustomerDetailsForms } from './coCustomerDetailsForms';
import { PrivateCustomerDetailsForms } from './privateCustomerDetailsForms';
import { initializeCreditApplicationData } from './utils';

type Props = {
  isCoCustomer: boolean;
};

export const CustomerDetailsForm: FunctionComponent<Props> = ({ isCoCustomer }) => {
  const dataStorageCustomData = useSelector(selectDataStorage);
  const { quoteId } = dataStorageCustomData;
  const { creditApplicationId } = useSelector(creditApplicationSelectors.selectCreditApplicationIds);
  const isCreditApplicationDataReady = useSelector(creditApplicationSelectors.selectIsCreditApplicationDataReady);
  const customerTypeFromQuote = useSelector(quoteSelectors.selectCustomerTypeFromQuote);

  useEffect(() => {
    if (isCreditApplicationDataReady) return;
    if (!quoteId || !creditApplicationId) return;
    initializeCreditApplicationData(quoteId, creditApplicationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteId, creditApplicationId]);

  const customerType =
    useSelector(creditApplicationSelectors.selectCustomerTypeFromCreditApplication) ?? customerTypeFromQuote;

  if (isCoCustomer) {
    return <CoCustomerDetailsForms />;
  }
  if (customerType === 'INDIVIDUAL') {
    return <PrivateCustomerDetailsForms />;
  }

  return <BusinessCustomerDetailsForms />;
};
